import { React, useState } from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    Textarea,
    Button,
    Card,
    Tabs
} from '@mantine/core';
import{
    IconGavel,
    IconMessage
} from '@tabler/icons';
import koenigsegg from '../assets/koenigsegg.jpg';


import { CarCardDetsBids } from '../components/CarCardDetsBids';
import { CommentCreationCard } from '../components/CommentCreationCard';
import { CommentCard } from '../components/CommentCard';

const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
        //width: "inherit"
    },
    defPadding: {
        padding: "8px"
    },
    commentBtn: {
        marginLeft: "4%",
        marginBottom: "3%",
        
    },
    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },
    displayArea: {
        width: "85%",
        margin: "0 auto"
    },
    panelArea: {
        //alignContent: "center",
        margin: "0 auto",
        alignItems: 'center',
    },

    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
}));

let authHold = {
    src: koenigsegg,
    name: "John Does"
}

export function BidsCommentsTabNav() {
    const { classes } = useStyles();
    const [activeTab, setActiveTab] = useState('first');
    return (
        <>
            <Tabs
                value={activeTab}
                onTabChange={setActiveTab}
                className={classes.displayArea}>
                <Tabs.List>
                    <Tabs.Tab value="first" icon={<IconMessage size={14} />}>Comments</Tabs.Tab>
                    <Tabs.Tab value="second" icon={<IconGavel size={14} />}>Bids</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="first">
                    <CommentCreationCard />
                    <br/>
                    <CommentCard
                        postedAt={"Mon. Jan 17th, 2023"}
                        body={" Praesent posuere arcu odio, quis gravida ipsum feugiat et. Sed et laoreet turpis, eget facilisis"}
                        author={authHold}
                    />
                    <br/>
                    <CommentCard
                        postedAt={"Mon. Jan 16th, 2023"}
                        body={"Duis vel eros maximus, vestibulum tortor vitae, suscipit augue."}
                        author={authHold}
                    />
                </Tabs.Panel>
                <Tabs.Panel className={classes.panelArea} value="second">
                    <CarCardDetsBids className={classes.panelArea}/>
                    <br/>
                    <CarCardDetsBids />
                    <br/>
                    <CarCardDetsBids />
                    <br/>
                    <CarCardDetsBids />
                    <br/>
                    <CarCardDetsBids />
                
                </Tabs.Panel>
            </Tabs>
        </>
    );
}
